import urljoin from 'url-join'
import axios from 'axios'
import ServicesUtils from '@/utils/servicesUtils'

async function subscribe (email, fromCityId, fromCampaignId)
{
    let url = urljoin(ServicesUtils.apiUrl, 'newsletters/subscribe')
    const response = await axios.post(url, { email, fromCityId, fromCampaignId })

    return response.data
}

export default { subscribe }


// WEBPACK FOOTER //
// ./src/services/newsletters.js